export default () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 36 28"
      width="36"
      height="36"
    >
      <path d="M36,13v2H0V13Zm-4-3H4V0H32ZM31,1H5V9H31ZM4,18H32V28H4Zm1,9H31V19H5Z"></path>
    </svg>
  );
};
